module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tagter"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagobj.type == 'terSt'),
      expression: "tagobj.type == 'terSt'"
    }]
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.terType[_vm.tagobj.vl],
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.terSt[_vm.tagobj.vl]))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagobj.type == 'nterSt'),
      expression: "tagobj.type == 'nterSt'"
    }]
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.nterType[_vm.tagobj.vl],
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.nterSt[_vm.tagobj.vl]))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagobj.type == 'openAuthType'),
      expression: "tagobj.type == 'openAuthType'"
    }]
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.openAuthType[_vm.tagobj.vl],
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm.openAuthSt[_vm.tagobj.vl]))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce2cc06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/tagc.vue
// module id = 986
// module chunks = 0